export default "__VITE_ASSET__CUJ5ABl4__"